module.exports = __webpack_public_path__ + "img/paused-status-icon.30af77a4.svg";